<template>
  <div class="form-source">
    <div
      role="alert"
      class="el-alert el-alert--warning is-light"
    >
      <div class="form-source-alert">
        <i class="el-alert__icon el-icon-warning is-big" />
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">waring</span>
          <p class="el-alert__description">
            公共代码保存后，对所有开发模式表单生效。部署后，对所有已部署的表单生效。
          </p>
        </div>
      </div>
      <div class="form-source-code-handle">
        <el-button
          size="mini"
          type="primary"
          :disabled="!sourceList.length"
          @click="publishAll"
        >
          全部部署
        </el-button>
        <el-button
          size="mini"
          type="primary"
          @click="deployHistory"
        >
          部署历史
        </el-button>
        <el-button
          size="mini"
          type="primary"
          @click="add"
        >
          新 增
        </el-button>
      </div>
    </div>
    <div
      v-if="sourceList.length"
      class="form-source-code"
    >
      <el-tabs
        v-model="index"
        type="card"
        size="mini"
        @tab-click="tabClick"
      >
        <el-tab-pane
          v-for="item in sourceList"
          :key="item.id"
          :label="item.name + '.' + item.type"
        />
      </el-tabs>
      <div class="align-right">
        <el-popconfirm
          :title="`确定删除${sourceList[index].name}.${sourceList[index].type}？`"
          @confirm="del"
        >
          <el-button
            slot="reference"
            size="mini"
            type="danger"
          >
            删 除
          </el-button>
        </el-popconfirm>
        <el-button
          size="mini"
          type="primary"
          @click="edit"
        >
          文件详情
        </el-button>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-s-promotion"
          @click="handlePublish"
        >
          部署
        </el-button>
        <el-button
          size="mini"
          type="primary"
          @click="allHistory"
        >
          变更历史
        </el-button>
        <el-button
          type="warning"
          size="mini"
          icon="el-icon-upload2"
          :loading="loading.save"
          @click="save"
        >
          保存
        </el-button>
      </div>
      <el-tabs
        v-model="index"
        size="mini"
        class="form-source-code-data"
      >
        <el-tab-pane
          v-for="item in sourceList"
          :key="item.id"
          :label="item.name + '.' + item.type"
          lazy
        >
          <WMonacoEditor
            v-model="item.codeData"
            :language="item.type === 'css' ? 'css' : 'javascript'"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-empty
      v-else
      :image-size="200"
    />
    <AddSource
      v-if="showAdd"
      :isEdit="isEdit"
      :value="sourceVal"
      @close="showAdd = false"
      @addSuccess="addSuccess"
    />
    <Publish
      v-if="showPublish"
      :value="publishRow"
      :type="publishType"
      @close="showPublish = false"
    />
    <History
      v-if="showHistory"
      :id="sourceList[index] ? sourceList[index].id : ''"
      :name="hideHandle ? '全部部署' : `${sourceList[index].name}.${sourceList[index].type} 更新`"
      :hideHandle="hideHandle"
      @close="historyClose"
      @reload="reload"
      @rollBack="rollBack"
    />
  </div>
</template>
<script>
import AddSource from './addSource.vue'
import Publish from '@workflow/components/public/codePublish.vue'
import History from '@workflow/components/public/codeUpdateHistory.vue'

export default {
  name: 'FormSource',
  components: {
    AddSource,
    Publish,
    History
  },
  data() {
    return {
      showCode: false,
      showAdd: false,
      isEdit: false,
      loading: {
        save: false
      },
      sourceVal: null,
      sourceList: [],
      index: '0',
      showHistory: false,
      showPublish: false,
      hideHandle: false,
      publishRow: {},
      publishType: '',
      historyId: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(id) {
      this.$api.public.selectAll().then(data => {
        const sourceList = data || []
        sourceList.forEach(item => {
          item.codeData = item.codeData || ''
        })
        this.sourceList = sourceList
        let index = '0'
        if (id) {
          const _index = sourceList.findIndex(item => item.id === id)
          if (_index >= 0) {
            index = _index + ''
          }
        }
        this.index = index
      })
    },
    edit() {
      this.sourceVal = JSON.parse(JSON.stringify(this.sourceList[this.index]))
      this.isEdit = true
      this.showAdd = true
    },
    add() {
      this.isEdit = false
      this.showAdd = true
    },
    addSuccess(val) {
      this.showAdd = false
      if (this.isEdit) {
        this.sourceList[this.index] = val
      } else {
        this.sourceList.push(val)
        if (this.sourceList.length === 1) {
          this.index = '0'
        }
      }
    },
    tabClick(params) {
      this.index = params.index + ''
    },
    save() {
      this.loading.save = true
      this.$api.public.save(this.sourceList[this.index]).then((data) => {
        this.$message.success('保存成功！')
        this.sourceList[this.index].version = data.version
      }).finally(() => {
        this.loading.save = false
      })
    },
    del() {
      this.$api.public.del({
        id: this.sourceList[this.index].id
      }).then((data) => {
        this.$message.success('删除成功！')
        this.init()
      })
    },
    historyClose() {
      this.showHistory = false
    },
    reload(id) {
      this.historyClose()
      this.init(id)
    },
    rollBack(data = {}) {
      this.sourceList[this.index].codeData = data.codeData || ''
    },
    publishAll() {
      this.publishRow = {}
      this.publishType = 'All'
      this.showPublish = true
    },
    handlePublish() {
      this.publishRow = this.sourceList[this.index]
      this.publishType = ''
      this.showPublish = true
    },
    allHistory() {
      this.hideHandle = false
      this.showHistory = true
    },
    deployHistory() {
      this.hideHandle = true
      this.showHistory = true
    }
  }
}

</script>
<style lang="scss">
.form-source {
  min-width: 900px;
  position: relative;

  .el-alert {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .form-source-alert {
    display: flex;
    align-items: center;
  }

  .form-source-code-handle {
    display: flex;
    align-items: flex-end;
  }

  .el-alert__title {
    font-size: 16px;
    line-height: 22px;
  }

  .el-alert__description {
    font-size: 14px;
    line-height: 18px;
  }

  .form-source-code {
    position: absolute;
    top: 80px;
    left: 10px;
    right: 10px;
    bottom: 10px;
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .align-right {
    margin-top: 6px;
    padding-right: 16px;
  }

  .form-source-code-data {
    position: absolute;
    top: 80px;
    right: 0;
    left: 0;
    bottom: 20px;

    .el-tabs__header {
      display: none;
    }

    .el-tabs__content,
    .el-tab-pane {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
  }

  .el-button {
    margin-left: 10px;
  }

  .el-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    padding: 40px 0;
  }

  .el-empty__description {
    margin-top: 20px;
  }
}

</style>
